/* La piastrella in stile card: sfogliare le fotografie e provare i colori.

   Due comandi, un file solo, e nessuno stato tenuto fuori dal DOM: l'indice
   della fotografia corrente si legge dagli elementi ogni volta. La griglia della
   collezione si ricostruisce a ogni filtro con la Section Rendering API, e
   qualunque cosa tenuta in una variabile qui parlerebbe di nodi buttati via.

   Per la stessa ragione gli ascoltatori stanno sul documento e non sulle
   piastrelle: quelli attaccati a una cella morirebbero con lei.

   Quello che questo copione NON fa: navigare. Le pillole sono collegamenti veri
   con l'indirizzo giusto gia' scritto nell'href, e cliccandole si va alla scheda
   con la variante scelta anche se questo file non arriva mai. */

(function () {
  'use strict';

  var PIASTRELLA = '.vdm-piastrella--card';

  function foto(piastrella) {
    return piastrella.querySelectorAll('.vdm-piastrella__img');
  }

  function mostra(piastrella, indice) {
    var scatti = foto(piastrella);
    if (!scatti.length) return;
    var i = Math.max(0, Math.min(indice, scatti.length - 1));
    for (var n = 0; n < scatti.length; n++) {
      scatti[n].classList.toggle('vdm-piastrella__img--sotto', n !== i);
    }

    var prec = piastrella.querySelector('[data-foto-prec]');
    var succ = piastrella.querySelector('[data-foto-succ]');
    /* La freccia indietro non esiste sulla prima, quella avanti non esiste
       sull'ultima. Un comando che non fa niente e' peggio di un comando
       assente: qui sparisce invece di restare spento. */
    if (prec) prec.hidden = i === 0;
    if (succ) succ.hidden = i === scatti.length - 1;
  }

  function indiceCorrente(piastrella) {
    var scatti = foto(piastrella);
    for (var n = 0; n < scatti.length; n++) {
      if (!scatti[n].classList.contains('vdm-piastrella__img--sotto')) return n;
    }
    return 0;
  }

  /* --- Sfogliare ------------------------------------------------------- */

  document.addEventListener('click', function (evento) {
    if (!evento.target.closest) return;
    var comando = evento.target.closest('[data-foto-prec], [data-foto-succ]');
    if (!comando) return;

    /* Il bottone sta sopra il link che copre tutta la piastrella: senza questo
       il clic sfoglierebbe e nello stesso istante aprirebbe la scheda. */
    evento.preventDefault();
    evento.stopPropagation();

    var piastrella = comando.closest(PIASTRELLA);
    if (!piastrella) return;
    var passo = comando.hasAttribute('data-foto-prec') ? -1 : 1;
    mostra(piastrella, indiceCorrente(piastrella) + passo);
  });

  /* --- Provare un colore ------------------------------------------------ */

  function taglieVisibili(piastrella, ammesse) {
    var voci = piastrella.querySelectorAll('.vdm-piastrella__taglia');
    for (var n = 0; n < voci.length; n++) {
      voci[n].hidden = ammesse
        ? ammesse.indexOf(voci[n].getAttribute('data-taglia')) < 0
        : false;
    }
  }

  function provaColore(pillola) {
    var piastrella = pillola.closest(PIASTRELLA);
    if (!piastrella) return;
    pillola.classList.add('e-provata');

    /* Il sottotitolo passa dall'elenco dei pellami al colore che si sta
       provando. E' l'unica cosa che cambia davvero finche' le varianti non
       avranno una fotografia loro: senza, passare sopra una pillola non
       darebbe nessun segno che sta succedendo qualcosa. */
    var sotto = piastrella.querySelector('.vdm-piastrella__sotto');
    if (sotto) {
      if (!sotto.hasAttribute('data-riposo')) {
        sotto.setAttribute('data-riposo', sotto.textContent);
      }
      sotto.textContent = pillola.getAttribute('data-colore') || sotto.textContent;
    }

    var taglie = pillola.getAttribute('data-taglie');
    taglieVisibili(piastrella, taglie ? taglie.split(',') : null);

    var sorgente = pillola.getAttribute('data-immagine');
    if (!sorgente) return;
    var prima = piastrella.querySelector('.vdm-piastrella__img');
    if (!prima) return;
    if (!prima.hasAttribute('data-riposo')) {
      prima.setAttribute('data-riposo', prima.getAttribute('src') || '');
      prima.setAttribute('data-riposo-srcset', prima.getAttribute('srcset') || '');
    }
    /* Lo srcset va spento, se no il browser continua a scegliere da li' e la
       fotografia non cambia: un difetto che si vede solo su schermi a densita'
       doppia, cioe' quasi mai in prova e sempre su un telefono vero. */
    prima.removeAttribute('srcset');
    prima.setAttribute('src', sorgente);
  }

  function smettiDiProvare(pillola) {
    var piastrella = pillola.closest(PIASTRELLA);
    if (!piastrella) return;
    pillola.classList.remove('e-provata');

    var sotto = piastrella.querySelector('.vdm-piastrella__sotto');
    if (sotto && sotto.hasAttribute('data-riposo')) {
      sotto.textContent = sotto.getAttribute('data-riposo');
    }

    taglieVisibili(piastrella, null);

    var prima = piastrella.querySelector('.vdm-piastrella__img');
    if (prima && prima.hasAttribute('data-riposo')) {
      prima.setAttribute('src', prima.getAttribute('data-riposo'));
      var srcset = prima.getAttribute('data-riposo-srcset');
      if (srcset) prima.setAttribute('srcset', srcset);
    }
  }

  /* `pointerover`/`pointerout` e non `pointerenter`/`pointerleave`: solo i primi
     due risalgono, e senza risalita un ascoltatore sul documento non li sente
     mai. `relatedTarget` serve a ignorare i passaggi *dentro* la pillola —
     entrando nella miniatura si uscirebbe e si rientrerebbe di continuo. */
  document.addEventListener('pointerover', function (evento) {
    if (!evento.target.closest) return;
    var pillola = evento.target.closest('.vdm-pillola');
    if (!pillola) return;
    if (pillola.contains(evento.relatedTarget)) return;
    provaColore(pillola);
  });

  document.addEventListener('pointerout', function (evento) {
    if (!evento.target.closest) return;
    var pillola = evento.target.closest('.vdm-pillola');
    if (!pillola) return;
    if (pillola.contains(evento.relatedTarget)) return;
    smettiDiProvare(pillola);
  });

  /* Da tastiera il fuoco fa le veci del puntatore: senza queste due righe le
     pillole si potrebbero attraversare col tabulatore senza vedere niente. */
  document.addEventListener('focusin', function (evento) {
    var pillola = evento.target.closest && evento.target.closest('.vdm-pillola');
    if (pillola) provaColore(pillola);
  });

  document.addEventListener('focusout', function (evento) {
    var pillola = evento.target.closest && evento.target.closest('.vdm-pillola');
    if (pillola) smettiDiProvare(pillola);
  });
})();
